module.exports = __webpack_public_path__ + "static/media/1006100.4ccf4d4d.png";